{
  "title": "Mental Prison",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level illusion",
  "level": 6,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You attempt to bind a creature within an illusory cell that only it perceives. One creature you can see within range must make an Intelligence saving throw. The target succeeds automatically if it is immune to being charmed. On a successful save, the target takes 5d10 psychic damage, and the spell ends. On a failed save, the target takes 5d10 psychic damage, and you make the area immediately around the target’s space appear dangerous to it in some way. You might cause the target to perceive itself as being surrounded by fire, floating razors, or hideous maws filled with dripping teeth. Whatever form the illusion takes, the target can’t see or hear anything beyond it and is restrained for the spell’s duration. If the target is moved out of the illusion, makes a melee attack through it, or reaches any part of its body through it, the target takes 10d10 psychic damage, and the spell ends."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
